export const CylinderProgress = ({
  label,
  value,
  target,
  actualTitle,
  targetTitle,
  fillColor,
  percentage,
}) => {
  // Determine color based on percentage

  const baseGradient = "#f3f4f6"; // light gray background

  return (
    <div>
      <div className="flex justify-between">
        <div className="text-xs font-[400] text-gray-700 mb-1 ">{label}</div>
        <div className="text-xs font-[400] text-gray-700 mb-1 ">
          {value} | {percentage}%
        </div>
      </div>
      <div className="relative w-full h-3 rounded-full overflow-hidden">
        <div
          className="w-full h-full rounded-full shadow-inner"
          style={{ backgroundColor: baseGradient }}
        />
        <div
          className="absolute top-0 left-0 h-full rounded-full shadow-[inset_-2px_2px_4px_rgba(0,0,0,0.2)]"
          style={{
            width: `${percentage}%`,
            backgroundColor: fillColor,
          }}
        />

        <div className="absolute inset-0 rounded-full bg-white opacity-10 pointer-events-none" />
        <div className="absolute top-0 left-0 w-full h-full flex justify-between items-center px-3 text-xs font-bold text-gray-700 cursor-pointer">
          <span
            className="text-gray-700"
            style={{
              width: `${percentage}%`,
            }}
          ></span>
        </div>
      </div>
    </div>
  );
};

export default CylinderProgress;
